
$controllers.accountremoval = {
	
	display : function($referral) {
		
		if (!$controllers.all.enforcePagePermissions('accountremoval')) { return false; }
		$models.teamsettings.activeUserIsOnlyAdminInMultiUserTeam(function($result) {
			if ($result == true) {
				$controllers.teamsettings.display();
				$soupmail.modal.notice('Before you can remove your account, you must nominate a new admin user who will look after this Soup Mail team once you leave.<br /><br />Please mark one or more of the users on this screen as a new admin user and then use the Delete Account function on the Profile page.<br /><br />Alternatively, if you wish to remove this Soup Mail team entirely, you will need to remove all users from the list on this screen and then use the Delete Account function on the Profile page.');
			} else {
				$controllers.all.showPage('accountremoval', 'contentpage');
				$controllers.all.setNavigation();
				if ($referral == 'team-settings'){
					jQuery('.cancel-button').click(function(e) {
						$controllers.teamsettings.display();
						e.preventDefault();
					});
				}else{
					jQuery('.cancel-button').click(function(e) {
						$controllers.profilesettings.display();
						e.preventDefault();
					});
				}	
			}
		});
		
	}
	
};

$controllers.alreadyactivated = {
	
	display : function() {
		$controllers.login.display();
		$soupmail.notification.error('The link you have clicked on has already been used to activate your user account.  Please log in using your username and password.');
	}
	
};

$controllers.activationsuccessful = {
	
	display : function() {
		if ($models.login.getToken()) {
			// alternate entry point to the application, lets replicate the $controllers.all.init() stuff here...
			$models.login.getMyUserDetails(function($data) {
				$models.login.cachedMyUserDetails = $data;
				$controllers.dashboard.display();
			});
		} else {
			$controllers.login.display();
			$soupmail.notification.message('Congratulations! Your Soup Mail account has been activated, please log in to start simplifying email sharing.');
		}
	}
	
};

$controllers.accountresetpassword = {
	
	display : function() {
		
		$controllers.all.showPage('accountresetpassword', 'contentpage');
		$controllers.all.setNavigation();
		
	},
	
	executePasswordResetRequest : function() {
		
		// quick validation
		if (!jQuery('#email').val()) {
			$soupmail.notification.error('Please ensure all fields are filled in');
			return false;
		}
		
		// send password request
		$formData = { email: jQuery('#email').val() };
		$models.users.getResetPassword($formData, function() {
			
			// success, so now login as the new user
			$controllers.login.display();
			$soupmail.notification.message('A password confirmation request has been been sent to your email address.  Please open up the email and click on the link to proceed to reset your password.');
			
		});
		
	}
	
};

$controllers.accountresetpasswordconfirm = {
	
	display : function() {
		
		$controllers.all.showPage('accountresetpasswordconfirm', 'contentpage');
		$views.accountresetpasswordconfirm.display();
		$controllers.all.setNavigation();
		
	},
	
	saveNewPassword : function() {
		
		// quick validation
		if (jQuery('#password').val().length < 8){
			$soupmail.modal.error('Password must be at least 8 characters');
			return false;
		}
		if (/^(?=.*[a-z])(?=.*[A-Z])/.test(jQuery('#password').val()) == false){
			$soupmail.modal.error('Password must have mixed case');
			return false;
		}
		if (/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(jQuery('#password').val()) == false){
			$soupmail.modal.error('Password must be alphanumeric');
			return false;
		}
		if (!jQuery('#password').val() || !jQuery('#password2').val()) {
			$soupmail.modal.error('Please ensure all fields are filled in');
			return false;
		}
		if (jQuery('#password').val() != jQuery('#password2').val()) {
			$soupmail.modal.error('Your password and confirmation password do not match');
			return false;
		}
		
		// save new password
		$formData = { token: $views.accountresetpasswordconfirm.token, user: { password: jQuery('#password').val() } };
		$models.users.setResetPassword($formData, function() {
			
			// success, so now login as the new user
			$controllers.login.display();
			$soupmail.notification.message('Your password has been reset.  You can now log in using your email address and new password.');
			
		});
		
	}
	
};

$controllers.accountactivationrequest = {
	
	display : function() {
		$controllers.accountexpired.display();
		jQuery('#activation-expired-message').hide();
		jQuery('#activation-request-message').show();
	}
	
};

$controllers.accountexpired = {
	
	display : function() {
		
		$controllers.all.showPage('accountexpired', 'contentpage');
		$controllers.all.setNavigation();
		$views.accountexpired.display();
		
	},
	
	save : function() {
		
		// remove any previous errors, if any
		jQuery('#system-message-container dl').remove();
		
		// quick validation
		if (!jQuery('#email').val()) {
			$soupmail.modal.error('Please ensure all fields are filled in');
			return false;
		}
		
		// init data
		$formData = { email: jQuery('#email').val() };
		
		// submit new token request
		$models.users.reactivateItem($formData, function() {
			
			// success, so now display activation page
			$controllers.accountsetup.display();
			
		});
		
	}
	
};

$controllers.accountsetup = {
	
	display : function() {
		
		$controllers.all.showPage('accountsetup', 'contentpage');
		$controllers.all.setNavigation();
		$views.accountsetup.display();
		
	}
	
};

$controllers.accountcreate = {
	
	display : function() {
		
		$controllers.all.showPage('accountcreate', 'contentpage');
		$controllers.all.setNavigation();
		$views.accountcreate.display();
	},
	
	displayTerms : function() {
		$models.accountcreate.getTerms(function($data) {
			$soupmail.modal.terms('Terms & conditions', '<div class="terms-conditions">'+$data.content+'</div>');
		});
	},
	
	save : function() {
		
		// quick validation
		if (!jQuery('#password').val() || !jQuery('#password2').val()) {
			$soupmail.notification.error('Please ensure all fields are filled in');
			return false;
		}
		if ((jQuery('.fields.team_name').css('display') != 'none') && !jQuery('#team_name').val()) {
			$soupmail.notification.error('Please ensure Team Name is filled in');
			return false;
		}
		if (!$models.profilesettings.validateFormData()) {
			return false;
		}
		if (!jQuery('#acceptterms').is(':checked')) {
			$soupmail.notification.error('You must agree to the terms and conditions in order to proceed');
			return false;
		}
		
		// init data
		jQuery('#name').val( jQuery('#first_name').val() + ' ' + jQuery('#last_name').val() );
	//	$teamData = { team: { name: jQuery('#name').val() } };
		$formData = { user: jQuery('#create_account_form').serializeObject() };
		
		// don't include Team Name if not applicable
		if (jQuery('.fields.team_name').css('display') == 'none') {
			delete $formData.user.team_name;
		}
		
		// are we creating a brand new user?
		if (!$views.accountcreate.isPrepopulated) {
			
			$('.create-button').hide();
			$('.cancel-button').hide();
			$('.create-button.grey').show();
			
			// create a user account
			$models.users.newItem($formData, function() {
				
				// success, so now login as the new user
				$controllers.login.login(jQuery('#email').val(), jQuery('#password').val());
				
			},
			function($error) {
				$soupmail.notification.error($error.error, 'An error occurred whilst creating a new user login');
				$('.create-button').show();
				$('.cancel-button').show();
				$('.create-button.grey').hide();
			});
			
		} else {
			
			$('.create-button').hide();
			$('.cancel-button').hide();
			$('.create-button.grey').show();
			
			// activate user account
			delete $formData.user.email;
			delete $formData.user.name;
			$formData.token = $views.accountcreate.token;
			$models.users.activateItem($formData, function() {
				
				// success, so now login as the new user
				$controllers.login.login(jQuery('#email').val(), jQuery('#password').val());
				
			},
			function($error) {
				$soupmail.notification.error($error.error, 'An error occurred whilst activating the user login for your account');
				$('.create-button').show();
				$('.cancel-button').show();
				$('.create-button.grey').hide();
			});
			
		}
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/accounts.js